import React, {Component} from 'react';
import Menu from "../components/Menu";
import {Route, Switch} from "react-router-dom";
import Overview from "./overview/Overview";
import Essaouira from "./essaouira/Essaouira";
import History from "./History";
import Contact from "./Contact";
import Footer from "../components/Footer";

class Site extends Component {

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }


    main_menu = [
        {
            title: "Overview",
            url: "/overview",
            sublinks: [
                {
                    title: "Gallery",
                    url: "/overview/gallery"
                },
                {
                    title: "Facts for the Visitor",
                    url: "/overview/facts"
                }
            ]
        },
        {
            title: "Booking",
            url: "https://www.airbnb.co.uk/rooms/14009842",
            sublinks: []
        },
        {
            title: "Essaouira",
            url: "/essaouira",
            sublinks: [
                {
                    title: "Festivals, Markets & Activities",
                    url: "/essaouira/activities"
                },
                {
                    title: "Flights & Local Transport",
                    url: "/essaouira/transport"
                }
            ]
        },
        {
            title: "History",
            url: "/history",
            sublinks: []
        },
        {
            title: "Contact",
            url: "/contact",
            sublinks: []
        },
    ];

    constructor(props) {
        super(props);
        this.handleCurrencyChange = this.handleCurrencyChange.bind(this);

        this.state = {
            currency: '£'
        }
    }

    handleCurrencyChange(currency) {
        this.setState({
            currency: currency
        })
    }

    render() {
        return (
            <div id={"page_wrapper"}>
                <div id={"header_wrapper"}>
                    <Menu id={"menu"} links={this.main_menu}/>
                </div>
                <main>
                    <div id={"content_wrapper"}>
                        <Switch>
                            <Route exact={true} path={"/"} render={() => this.renderSplash()}/>
                            <Route path={"/overview"} render={() => <Overview/>}/>
                            <Route path={"/essaouira"} render={() => <Essaouira/>}/>
                            <Route path={"/history"} render={() => <History/>}/>
                            <Route path={"/contact"} render={() => <Contact/>}/>
                        </Switch>
                    </div>
                </main>
                <footer>
                    <Footer currency={this.state.currency}
                            handleCurrencyChange={this.handleCurrencyChange}/>
                </footer>
            </div>
        );
    }


    renderSplash() {
        return (
            <div id={"title_wrapper"}>
                <h1 id={"main_title"}>RIAD<br/>REMMY</h1>
                <h3 id={"sub_title"}>Essaouira | Morocco</h3>
            </div>
        );
    }

    handleScroll() {
        const header = document.getElementById("header_wrapper");

        if (window.pageYOffset > 0) {
            header.classList.add("sticky");
        } else {
            header.classList.remove("sticky");
        }
    }
}

export default Site;
